import React, { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

export default function Connexion() {
  const { login } = useAuth();
  useEffect(() => { login(); }, [login]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground font-mono text-sm">Redirection vers la connexion…</p>
      </div>
    </div>
  );
}
